<!--<ul class="navbar">
  <li class="nav-item" style="float:left">Danh sách lớp đang theo học</li>
  <li class="nav-item active">
    <a class="nav-link" (click)="save_chondoituong()">
      <i style="color:red" class="fa-2x mr-2 far fa-window-close"></i>
      Thoát
    </a>
  </li>

</ul>-->



<div class="row">
  <div class="col-4">
    <!--<label class="control-label" style="font-weight:bold;color:cornflowerblue">Danh sách lớp đang theo học</label>-->
    <button class="btn btn-info btn-primary" style="float:right;margin-right:6px" (click)="search()">
      <i class="fas fa-search"></i>
      {{'Tìm kiếm' | translate}}
    </button>
  </div>
  <div class="col-4">
    <ng-select #slChiNhanh
               class="twcollong"
               [tabIndex]="4"
               [openOnEnter]="false"
               [items]="dschinhanhs"
               bindValue="Id"
               bindLabel="Ten"
               tabindex="25"
               notFoundText="Không có dữ liệu"
               placeholder="Chọn trung tâm..."
               [searchFn]="comboSearchFn2"
               (change)="changeChiNhanh1($event)"
               [(ngModel)]="TimKiems.DonViId">
      <ng-template ng-option-tmp let-item="item">
        <div class="rTableRow">
          <div class="rTableCell_1">{{item.Ten}}</div>
        </div>
      </ng-template>
    </ng-select>
  </div>
  <div class="col-4">
    <ng-select #slLop
               class="twcollong"
               [tabIndex]="3"
               [openOnEnter]="false"
               [items]="dslops"
               bindValue="Id"
               bindLabel="Ten"
               tabindex="26"
               notFoundText="Không có dữ liệu"
               placeholder="Lọc danh sách theo lớp..."
               [searchFn]="comboSearchFn2"
               (change)="changeLopTimKiem($event)"
               [(ngModel)]="TimKiems.LopId">
      <ng-template ng-option-tmp let-item="item">
        <div class="rTableRow">
          <div class="rTableCell_1">{{item.Ten}}</div>
        </div>
      </ng-template>
    </ng-select>
  </div>
</div>

<!-- lưới chi tiết -->
<div class="row" style="margin-left: -10px;margin-top: 2px;overflow:auto">
  <div style="padding: 0px 0px 5px 0px;color:black !important; height: calc(100vh - 200px);width:100%">
    <table id="fixTable5" class="table table-striped table-bordered table-hover table-condensed">
      <thead>
        <!--<thead>-->
        <tr>
          <th style="width:40px;text-align:center;background-color:#f3f8fc">STT</th>
          <th style="width:50px;text-align:center;background-color:#f3f8fc">{{'Chọn' | translate}}</th>
          <th style="min-width:120px;text-align:center;background-color:#f3f8fc">Trạng thái</th>
          <th *ngIf="CauHinhHienThis['Tài khoản']===true" style="min-width:120px;text-align:center;background-color:#f3f8fc">Tài khoản</th>
          <th style="min-width:120px;text-align:center;background-color:#f3f8fc">Tên học viên</th>
          <th *ngIf="CauHinhHienThis['Bí danh']===true" style="min-width:120px;text-align:center;background-color:#f3f8fc">Bí danh</th>
          <th style="min-width:120px;text-align:center;background-color:#f3f8fc">Tên phụ huynh</th>
          <th style="min-width:120px;text-align:center;background-color:#f3f8fc">Số điện thoại</th>
          <th style="min-width:120px;text-align:center;background-color:#f3f8fc">Tên lớp</th>
          <th *ngIf="CauHinhHienThis['Phụ trách']===true" style="min-width:120px;text-align:left;background-color:#f3f8fc">Phụ trách</th>


        </tr>

        <tr class="filter-row">
          <td style="text-align:center"></td>
          <td style="text-align:center">
            <input type="checkbox" [(ngModel)]="TatCa" (click)="TichTatCa()" />
          </td>
          <td style="text-align:center">
            <ng-select #slTrangThai
                       class="twcollong"
                       [tabIndex]="3"
                       [openOnEnter]="false"
                       [items]="dstrangthais"
                       bindValue="Id"
                       bindLabel="Ten"
                       notFoundText="Không có dữ liệu"
                       [searchFn]="comboSearchFn2"
                       (change)="changeTrangThai($event)"
                       [(ngModel)]="TimKiems.TrangThai">
              <ng-template ng-option-tmp let-item="item">
                <div class="rTableRow">
                  <div class="rTableCell">{{item.Ten}}</div>
                </div>
              </ng-template>
            </ng-select>
          </td>

          <td *ngIf="CauHinhHienThis['Tài khoản']===true">
            <input class="form-control" style="width:100%;font-style:italic;font-size:11px;height:25px !important" type="text"
                   [(ngModel)]="TimKiems.TaiKhoan" placeholder="Tìm kiếm" (keydown)=onKeydownEvent($event)>
          </td>
          <td>
            <input class="form-control" style="width:100%;font-style:italic;font-size:11px;height:25px !important" type="text"
                   [(ngModel)]="TimKiems.HoTen" placeholder="Gõ ký tự và ấn enter" (keydown)=onKeydownEvent($event)>
          </td>
          <td *ngIf="CauHinhHienThis['Bí danh']===true">
            <input class="form-control" style="width:100%;font-style:italic;font-size:11px;height:25px !important" type="text"
                   [(ngModel)]="TimKiems.BiDanh" placeholder="Tìm kiếm" (keydown)=onKeydownEvent($event)>
          </td>
          <td>
            <input class="form-control" style="width:100%;font-style:italic;font-size:11px;height:25px !important" type="text"
                   [(ngModel)]="TimKiems.TenPhuHuynh" placeholder="Tìm kiếm" (keydown)=onKeydownEvent($event)>
          </td>
          <td>
            <input class="form-control" style="width:100%;font-style:italic;font-size:11px;height:25px !important" type="text"
                   [(ngModel)]="TimKiems.SoDienThoai" placeholder="Tìm kiếm" (keydown)=onKeydownEvent($event)>
          </td>
          <td>
            
          </td>
          <td *ngIf="CauHinhHienThis['Phụ trách']===true">
            <input class="form-control" style="width:100%;font-style:italic;font-size:11px;height:25px !important" type="text"
                   [(ngModel)]="TimKiems.PhuTrach" placeholder="Tìm kiếm" (keydown)=onKeydownEvent($event)>
          </td>

        </tr>

      </thead>
      <tbody style="max-height:calc(100vh - 280px);">
        <tr *ngFor="let u of datas">
          <td style="width:40px;text-align:center"><a>{{u.STT}}</a></td>
          <td style="text-align:center;width:50px"><input type="checkbox" [(ngModel)]="u.Tich" /></td>
          <td style="min-width:120px">
            <!--<a>{{u.TrangThai}}</a>-->
            <div class="x-grid-cell-inner" style="text-align: center;">
              <a *ngIf="u.TT==1" style="background-color: #00a651!important;border-radius: 5px;font-size: 12px;padding: 2px 8px;color: #FFFFFF;">
                {{u.TrangThai}}
              </a>
              <a *ngIf="u.TT==2" style="background-color: orange !important;border-radius: 5px;font-size: 12px;padding: 2px 8px;color: #FFFFFF;">
                {{u.TrangThai}}
              </a>
              <a *ngIf="u.TT==0" style="background-color: red !important;border-radius: 5px;font-size: 12px;padding: 2px 8px;color: #FFFFFF;">
                {{u.TrangThai}}
              </a>

            </div>
          </td>
          <td *ngIf="CauHinhHienThis['Tài khoản']===true" style="min-width:120px"><a>{{u.UserName}}</a></td>
          <td style="min-width:120px"><a>{{u.HoVaTen}}</a></td>
          <td *ngIf="CauHinhHienThis['Bí danh']===true" style="min-width:120px"><a>{{u.TenGoiKhac}}</a></td>
          <td style="min-width:120px"><a>{{u.TenPhuHuynh}}</a></td>
          <td style="min-width:120px"><a>{{u.DienThoaiDiDong}}</a></td>
          <td style="min-width:120px">{{u.TenLop}}</td>
          <td *ngIf="CauHinhHienThis['Phụ trách']===true" style="min-width:120px">{{u.PhuTrach}}</td>

        </tr>
      </tbody>
    </table>


  </div>

</div>





<div class="modal-footer" style="display: flex;justify-content: space-between;margin-top:5px;">
  <div>
    <div *ngIf="totalItems>=10">
      <ul class="pagination">
        <li [ngClass]="{disabled: currentPage === 1}">
          <a (click)="setPage(1)"><<</a>
        </li>
        <li [ngClass]="{disabled:currentPage === totalPages}">
          <a (click)="setPage(currentPage + 1)">></a>
        </li>
        <li *ngFor="let page of pages" [ngClass]="{active: currentPage === page.Id}">
          <a (click)="setPage(page.Id)">{{page.Id}}</a>
        </li>
        <li [ngClass]="{disabled:currentPage === 1}">
          <a (click)="setPage(currentPage - 1)"><</a>
        </li>
        <li [ngClass]="{disabled:currentPage === totalPages}">
          <a (click)="setPage(totalPages)">>></a>
        </li>
        <li>
          <input type="number" style="width:50px;height:25px;text-align:center" [(ngModel)]="pageSize" (blur)="search1()" />
        </li>
        <li><span style="font-weight:bold">Tổng số: {{totalItems | number}}</span></li>
      </ul>
    </div>
  </div>
  <div class="">
    <button type="submit" (click)="saveproduct()" title="Ấn F9 để lưu" class="mb-1 mr-1 btn btn-primary" style="padding-top:0px !important">{{'Lưu lại' | translate}}</button>
    <button class="mb-1 mr-1 btn btn-secondary" (click)="save_chondoituong()" title="Ấn ESC để thoát" style="padding-top:0px !important">Đóng lại</button>
  </div>

</div>








